import { render, staticRenderFns } from "./InformationAboutStudentMovementTable.vue?vue&type=template&id=78183f06&"
import script from "./InformationAboutStudentMovementTable.vue?vue&type=script&lang=js&"
export * from "./InformationAboutStudentMovementTable.vue?vue&type=script&lang=js&"
import style0 from "./InformationAboutStudentMovementTable.vue?vue&type=style&index=0&id=78183f06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports